export default __webpack_public_path__ + "static/media/conway_claim_small.92abe935.jpg";